import videoAPI from '../../../utils/videoAPI';
import toolkitApi from '../../toolkitApi';

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        NHLStats: build.query({
            async queryFn(args, queryApi, extraOptions, fetchWithBQ) {
                const [{ data }, videoDetailMap] = await Promise.all([
                    fetchWithBQ(args.url),
                    videoAPI.getVideoDetailsMapFromRecord(fetchWithBQ, args.record),
                ]);
                const nhlData = videoAPI.addVideoIdToDataset(data.data, videoDetailMap);
                return { data: nhlData };
            },
        }),
    }),
});
